import React from 'react';
import { registryPageData } from '@data-ts/pages/registry';
import { SearchBar } from '@sections/shared/SearchBar';
import { StyledNavWrapper, StyledSection, StyledText, StyledWrapper } from './RegistryTopBarSection.styles';
import { ReactComponent as SearchIcon } from '@sections/shared/SearchBar/search.svg';
import { CTALink } from '@components/CTALink';
const { shopSearch } = registryPageData;

const NAV_DATA = [
  { name: 'Brands', link: '/shop/brands' },
  { name: 'Collections', link: '/shop/curations' },
  {
    name: 'Kitchen',
    link: '/shop/catalog/kitchen',
  },
  {
    name: 'Tabletop',
    link: '/shop/catalog/tabletop',
  },
  {
    name: 'Bed & Bath',
    link: '/shop/catalog/bed-bath',
  },
  {
    name: 'Home',
    link: '/shop/catalog/home',
  },
  {
    name: 'Travel & Leisure',
    link: '/shop/catalog/lifestyle',
  },
  {
    name: 'Cash Funds',
    link: '/shop/catalog/cash-funds',
  },
  {
    name: 'Experiences',
    link: '/shop/catalog/experiences',
  },
];

export const RegistryTopBarSection = () => {
  return (
    <StyledSection as="section" id="Registry_Topbar_Section">
      <StyledWrapper>
        <SearchBar
          submitLabel={<SearchIcon css={{ fill: 'white' }} />}
          placeHolder={shopSearch.placeHolder}
          eventName="RegistrySearched"
          variant="secondary"
          id="registry"
          enabledAmplitude={true}
        />
        <StyledNavWrapper as="nav">
          {NAV_DATA.map(item => (
            <CTALink key={item.name} id={item.name} variant="primary" href={item.link}>
              <StyledText tagName="p" variant="featureCopy17">
                {item.name}
              </StyledText>
            </CTALink>
          ))}
        </StyledNavWrapper>
      </StyledWrapper>
    </StyledSection>
  );
};
